var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var CarMd = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--medium", className].filter(Boolean).join(" "),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96 1a3.5 3.5 0 0 0-3.433 2.814l-.473 2.368C1.43 6.482 1 7.12 1 7.857V10.5c0 1.21.857 2.22 2 2.45v.55A1.5 1.5 0 0 0 4.5 15h1A1.5 1.5 0 0 0 7 13.5V13h2v.5a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-.55c1.143-.23 2-1.24 2-2.45V7.857c0-.738-.43-1.375-1.054-1.675l-.473-2.368A3.5 3.5 0 0 0 10.04 1H5.959Zm7.606 6.111a3.246 3.246 0 0 1-.783.363C11.961 7.748 10.526 8 8 8c-2.526 0-3.961-.252-4.783-.526a3.247 3.247 0 0 1-.783-.363.857.857 0 0 0-.434.746V10.5c0 .83.669 1.5 1.496 1.5h9.007c.828 0 1.497-.67 1.497-1.5V7.857a.857.857 0 0 0-.434-.746ZM12 13h-2v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V13Zm-6 0H4v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V13ZM3.533 6.526a2.557 2.557 0 0 1-.486-.21l.461-2.306A2.5 2.5 0 0 1 5.959 2h4.082a2.5 2.5 0 0 1 2.451 2.01l.461 2.306c-.095.056-.248.13-.486.21C11.789 6.752 10.474 7 8 7c-2.474 0-3.789-.248-4.467-.474ZM6 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  }));
});
CarMd.displayName = "CarMd";
export default CarMd;